import axiosInstance from '../utils/axiosInstance';

interface OverridePrescriptionResponse {
  success: boolean;
  data: { prescription: Record<string, unknown> };
}

export const overridePrescription = async (
  matterId: string,
  date: string,
  reason: string,
): Promise<Record<string, unknown>> => {
  const response = await axiosInstance.post<OverridePrescriptionResponse>(
    `/matters/${matterId}/prescription/override`,
    { date, reason },
  );
  return response.data.data.prescription;
};

export const PRESCRIPTION_OVERRIDE_REASONS: string[] = [
  'Court order / condonation granted',
  'Confirmed correct date from RAF',
  'Incorrect accident date originally extracted',
  "Minor's 18th birthday confirmed",
  'Other (see notes)',
];
